// 공개 사용자 매뉴얼(/manual/)에서 화면별로 여는 쪽. 짝이 없으면 매뉴얼 첫 화면.
// 쪽 번호는 docs/manual/content/<id>.json 과 같다 (public/manual/<id>.html).
export const MANUAL_ROOT = '/manual/';
// 앞에서부터 처음 맞는 줄. '/dashboard' 만 대시보드 변형(/dashboard-xxx)까지 받는다.
const PAGE_BY_PATH = [
  ['/simplelineplus/kpi', '15-03'],
  ['/simplelineplus', '15-01'],
  ['/dashboard', '15-01', true],
  ['/kpi', '15-03'],
  ['/production', '15-05'],
  ['/contract', '15-08'],
  ['/product-stock', '15-19'],
  ['/product', '15-15'],
  ['/material', '15-24'],
  ['/process', '15-29'],
  ['/machine', '15-32'],
  ['/partner', '15-34'],
];
export const manualHrefFor = (pathname) => {
  const p = String(pathname || '');
  const hit = PAGE_BY_PATH.find(([prefix, , variants]) =>
    p === prefix || p.startsWith(`${prefix}/`) || (variants && p.startsWith(`${prefix}-`)));
  return hit ? `${MANUAL_ROOT}${hit[1]}.html` : MANUAL_ROOT;
};
